module.exports = __webpack_public_path__ + "frontend-assets/img/PHOTOS_350x350px_32.82aa7578.png";